export const setEasy = () => {
    return {
        type: "EASY"
    }
}

export const setMedium = () => {
    return {
        type: "MEDIUM"
    }
}

export const setHard = () => {
    return {
        type: "HARD"
    }
}
